"use strict";
document.addEventListener("turbo:load", () => {
  const callout = document.querySelector(".flash[role='alert']");
  if (!callout) {
    return;
  }
  setTimeout(() => {
    callout.setAttribute("tabindex", "0");
    callout.focus();
    callout.innerHTML += "&nbsp;";
  }, 500);
});
